import React from 'react';

//components
import BlogCard from './BlogCard';
//domains
import type {SanityDocBlog} from 'domains/blog';

export default function Blogs({blogs}: {blogs: SanityDocBlog[]}) {
  return (
    <ul className="grid gap-y-8 gap-x-[72px] md:col-span-2 md:grid-cols-2 md:gap-y-24 mb-10">
      {blogs ? (
        blogs.map((b, i) => {
          if (i > 2) {
            return (
              <li key={`${b._id}`} className="md:col-span-1">
                <BlogCard {...b} type="vertical" />
              </li>
            );
          }
          return (
            <li key={b._id} className="md:col-span-2">
              <BlogCard {...b} />
            </li>
          );
        })
      ) : (
        <>No blog posts</>
      )}
    </ul>
  );
}
